export const isProduction = process.env.NODE_ENV === "production";

const config = {
  gtm: {
    id: "GTM-P257L7B"
  },
  stripe: {
    key: isProduction
      ? "pk_live_mIIVRaa2HwgFIv3JgIf8XRHp"
      : "pk_test_s2UCJ5ulUf8PLG2ggfGFZ3Ty"
  },
  mixpanel: {
    key: isProduction
      ? "0a9c9627a67d3492bbc34cc268ffd035"
      : "12003c166a134aa4dd01c4ae19029d43"
  }
};

export default config;



// WEBPACK FOOTER //
// ./src/utils/config.js